var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"w-1/2 pr-6"},[_c('SMSForm')],1),_c('div',{staticClass:"w-1/2 pl-6"},[_c('SmsPreview')],1)]),_c('base-button',{attrs:{"type":"success"}},[_vm._v("Submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }